import { render, staticRenderFns } from "./boxShow.vue?vue&type=template&id=3eeec05c&"
import script from "./boxShow.vue?vue&type=script&lang=ts&"
export * from "./boxShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports